import { call, put } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { Auth } from "aws-amplify";

import { getCognitoUser, removeCognitoInfo } from "../../helpers";
import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzSetNewPasswordRequired(CognitoUser: Record<string, any>, password: string): Generator<any, any, any> {
  // TS Definition indicates that third parameter is required, so setting undefined because previous code was not passing anything.

  return yield Auth.completeNewPassword(CognitoUser, password, undefined);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzSetNewPasswordRequiredWorker(action: any): Generator<any, any, any> {
  try {
    const { payload, navigate } = action;
    const { password } = payload;
    const CognitoUser = yield getCognitoUser();

    yield put(startSubmit("SetNewPasswordForm"));
    yield call(authnzSetNewPasswordRequired, CognitoUser, password);
    yield put(stopSubmit("SetNewPasswordForm"));

    yield removeCognitoInfo();

    yield put(MiniMessageBox.hideMiniBoxMessage());
    yield payload.onStateChange("signedIn", {});
    navigate("/");
  } catch (error) {
    yield put(stopSubmit("SetNewPasswordForm"));

    if (error instanceof Error) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
    }
  }
}
